import { SortIcon } from 'images'
import React, { FC } from 'react'
import { HeaderCell, HeaderItemContent, SortIconContainer } from './styled'
import { useSearchApprovedContext } from 'pages/approve/context/SearchApprovesContext'
import { OrderByFieldApproveEmployees } from 'pages/approve/context/types'

interface Props {
    title: string
    name?: OrderByFieldApproveEmployees['field'] | 'comment'
}

export const HeaderItem: FC<Props> = ({ title, name }) => {
    const { orderBy, setOrderBy } = useSearchApprovedContext()

    const onFilterChange = () => {
        if (name) {
            if (orderBy && orderBy.field === name) {
                if (orderBy.asc) {
                    setOrderBy({ field: name, asc: false })
                } else {
                    setOrderBy(null)
                }
            } else {
                if (name !== 'comment') setOrderBy({ field: name, asc: true })
            }
        }
    }

    return (
        <HeaderCell>
            <HeaderItemContent onClick={onFilterChange}>
                {title}{' '}
                {name && (
                    <SortIconContainer
                        hidden={orderBy === null || orderBy.field !== name}
                        reversed={!!(orderBy && orderBy.field === name && !orderBy.asc)}
                    >
                        <SortIcon />
                    </SortIconContainer>
                )}
            </HeaderItemContent>
        </HeaderCell>
    )
}
